import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/gossip';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20artistic%20composition%20with%20warm%20golden%20and%20amber%20geometric%20shapes%20floating%20on%20deep%20charcoal%20background%2C%20minimal%20modern%20design%2C%20soft%20gradient%20glow%2C%20cinematic%20atmosphere%2C%20luxurious%20texture%2C%20elegant%20composition%2C%20no%20text%2C%20clean%20lines%2C%20art%20deco%20inspired%20pattern&width=1600&height=900&seq=gossip-hero-main&orientation=landscape"
          alt="吃瓜网 - 全网吃瓜官网深夜猛料直达"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="flex items-center gap-2 mb-6 animate-in fade-in duration-500">
          <div className="w-8 h-8 flex items-center justify-center bg-accent-500/90 rounded-lg">
            <i className="ri-fire-line text-background-50 text-base"></i>
          </div>
          <span className="text-sm font-medium text-background-50/90 tracking-wide">
            深夜猛料 · 实时更新
          </span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 text-center font-heading max-w-4xl leading-tight animate-in fade-in slide-in-from-bottom-4 duration-500 delay-100">
          全网最劲爆内幕
          <br />
          <span className="text-accent-400">明星塌房</span> 与 <span className="text-primary-400">网红黑料</span> 直达
        </h1>

        <p className="mt-4 md:mt-5 text-sm md:text-base text-background-50/70 text-center max-w-2xl animate-in fade-in duration-500 delay-200">
          吃瓜网入口实时追踪全网最劲爆内幕，明星塌房与网红反差视频凌晨流出直达。热门大瓜聊天记录全网首发，精彩猛料持续更新中
        </p>

        <div className="mt-6 md:mt-8 flex items-center gap-3 animate-in fade-in slide-in-from-bottom-6 duration-500 delay-300">
          <Link
            to={`/article/${featuredArticles[0].slug}`}
            className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-full transition-all whitespace-nowrap cursor-pointer"
          >
            立即吃瓜
            <i className="ri-arrow-right-line ml-1.5"></i>
          </Link>
          <a
            href="#latest"
            className="px-6 py-3 border border-background-50/40 hover:border-background-50/80 text-background-50 font-medium text-sm rounded-full transition-all whitespace-nowrap cursor-pointer"
          >
            浏览猛料
            <i className="ri-arrow-down-line ml-1.5"></i>
          </a>
        </div>

        <div className="absolute bottom-6 md:bottom-10 flex items-center gap-2 animate-in fade-in duration-500 delay-500">
          <div className="flex items-center gap-1.5 px-3 py-1.5 bg-background-50/10 backdrop-blur-sm rounded-full">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            <span className="text-xs text-background-50/80">实时在线吃瓜人数：128,930</span>
          </div>
        </div>
      </div>
    </section>
  );
}